<template>
    <b-row>
        <PmisPresentationFeatures :cols="4" :features="features" :name="name" :title="title" :idx="idx"
                                  class="pmis-container"></PmisPresentationFeatures>
        <PmisPresentationImageContainer :images="images" :name="name" :idx="idx"
                                        class="pmis-container"></PmisPresentationImageContainer>
    </b-row>
</template>

<script>
    import PmisPresentationFeatures from "./PmisPresentationFeatures";
    import PmisPresentationImageContainer from "./PmisPresentationImagesContainer";

    export default {
        name: "PmisPresentation",
        components: {PmisPresentationImageContainer, PmisPresentationFeatures},
        props: {
            name: String,
            presentationData: Object,
            idx: Number
        },
        computed: {
            title() {
                return this.presentationData.title;
            },
            features() {
                if (this.presentationData.menu.length <= 0 || this.presentationData.menu[0].text != "Navodila")
                    throw new Error('Component definition error! Please fix the JSON according to the instructions.');

                return this.presentationData.menu[0].content.items.slice(0,5).map(value => value.title);
            },
            images() {
                return this.presentationData.images;
            }
        }
    }
</script>

<style lang="scss" scoped>
    .pmis-presentation-container {
        margin-top: 20px;
    }
</style>
